import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext.jsx';
import { uploadUrl } from '../api/client.js';

// Sama persis dengan NAV_ITEMS di Navbar.jsx (desktop) supaya menu footer selalu sinkron.
const NAV_ITEMS = [
  { label: 'Beranda', to: '/', icon: 'home' },
  { label: 'Layanan', to: '/layanan', icon: 'auto_awesome' },
  { label: 'Portofolio', to: '/portofolio', icon: 'grid_view' },
  { label: 'Testimoni', to: '/testimoni', icon: 'format_quote' },
  { label: 'Jadwal', to: '/jadwal', icon: 'calendar_month' },
  { label: 'Kontak', to: '/kontak', icon: 'edit_calendar' },
];

const INFO_ITEMS = [
  { label: 'Testimoni', to: '/testimoni' },
  { label: 'Jadwal & Info', to: '/jadwal' },
  { label: 'Kontak', to: '/kontak' },
];

// Desktop: judul + list statis. Mobile: berubah jadi accordion,
function FooterAccordion({ title, items }) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <h4 className="hidden md:block text-white font-bold text-sm mb-5 tracking-wider uppercase">{title}</h4>
      <ul className="hidden md:block space-y-3">
        {items.map((item) => (
          <li key={item.to}>
            <Link to={item.to} className="text-sm text-neutral-400 hover:text-white transition-colors">
              {item.label}
            </Link>
          </li>
        ))}
      </ul>

      <div className="md:hidden border-b border-white/10">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="w-full flex items-center justify-between text-white font-bold text-sm tracking-wider uppercase py-3"
        >
          <span>{title}</span>
          <span
            className="material-symbols-outlined transition-transform duration-300"
            style={{ transform: open ? 'rotate(180deg)' : 'none' }}
          >
            expand_more
          </span>
        </button>
        <div className="grid transition-[grid-template-rows] duration-500 ease-out" style={{ gridTemplateRows: open ? '1fr' : '0fr' }}>
          <div className="overflow-hidden">
            <ul className="space-y-3 pt-1 pb-4">
              {items.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-sm text-neutral-400 hover:text-white transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

function WhatsAppIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.50002 12C3.50002 7.30558 7.3056 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C10.3278 20.5 8.77127 20.0182 7.45798 19.1861C7.21357 19.0313 6.91408 18.9899 6.63684 19.0726L3.75769 19.9319L4.84173 17.3953C4.96986 17.0955 4.94379 16.7521 4.77187 16.4751C3.9657 15.176 3.50002 13.6439 3.50002 12ZM12 1.5C6.20103 1.5 1.50002 6.20101 1.50002 12C1.50002 13.8381 1.97316 15.5683 2.80465 17.0727L1.08047 21.107C0.928048 21.4637 0.99561 21.8763 1.25382 22.1657C1.51203 22.4552 1.91432 22.5692 2.28599 22.4582L6.78541 21.1155C8.32245 21.9965 10.1037 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM14.2925 14.1824L12.9783 15.1081C12.3628 14.7575 11.6823 14.2681 10.9997 13.5855C10.2901 12.8759 9.76402 12.1433 9.37612 11.4713L10.2113 10.7624C10.5697 10.4582 10.6678 9.94533 10.447 9.53028L9.38284 7.53028C9.23954 7.26097 8.98116 7.0718 8.68115 7.01654C8.38113 6.96129 8.07231 7.046 7.84247 7.24659L7.52696 7.52195C6.76823 8.18414 6.3195 9.2723 6.69141 10.3741C7.07698 11.5163 7.89983 13.314 9.58552 14.9997C11.3991 16.8133 13.2413 17.5275 14.3186 17.8049C15.1866 18.0283 16.008 17.7288 16.5868 17.2572L17.1783 16.7752C17.4313 16.5691 17.5678 16.2524 17.544 15.9269C17.5201 15.6014 17.3389 15.308 17.0585 15.1409L15.3802 14.1409C15.0412 13.939 14.6152 13.9552 14.2925 14.1824Z" />
    </svg>
  );
}

function InstagramIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M289.869652,7279.12273 C288.241769,7279.19618 286.830805,7279.5942 285.691486,7280.72871 C284.548187,7281.86918 284.155147,7283.28558 284.081514,7284.89653 C284.035742,7285.90201 283.768077,7293.49818 284.544207,7295.49028 C285.067597,7296.83422 286.098457,7297.86749 287.454694,7298.39256 C288.087538,7298.63872 288.809936,7298.80547 289.869652,7298.85411 C298.730467,7299.25511 302.015089,7299.03674 303.400182,7295.49028 C303.645956,7294.859 303.815113,7294.1374 303.86188,7293.08031 C304.26686,7284.19677 303.796207,7282.27117 302.251908,7280.72871 C301.027016,7279.50685 299.5862,7278.67508 289.869652,7279.12273 M289.951245,7297.06748 C288.981083,7297.0238 288.454707,7296.86201 288.103459,7296.72603 C287.219865,7296.3826 286.556174,7295.72155 286.214876,7294.84312 C285.623823,7293.32944 285.819846,7286.14023 285.872583,7284.97693 C285.924325,7283.83745 286.155174,7282.79624 286.959165,7281.99226 C287.954203,7280.99968 289.239792,7280.51332 297.993144,7280.90837 C299.135448,7280.95998 300.179243,7281.19026 300.985224,7281.99226 C301.980262,7282.98483 302.473801,7284.28014 302.071806,7292.99991 C302.028024,7293.96767 301.865833,7294.49274 301.729513,7294.84312 C300.829003,7297.15085 298.757333,7297.47145 289.951245,7297.06748 M298.089663,7283.68956 C298.089663,7284.34665 298.623998,7284.88065 299.283709,7284.88065 C299.943419,7284.88065 300.47875,7284.34665 300.47875,7283.68956 C300.47875,7283.03248 299.943419,7282.49847 299.283709,7282.49847 C298.623998,7282.49847 298.089663,7283.03248 298.089663,7283.68956 M288.862673,7288.98792 C288.862673,7291.80286 291.150266,7294.08479 293.972194,7294.08479 C296.794123,7294.08479 299.081716,7291.80286 299.081716,7288.98792 C299.081716,7286.17298 296.794123,7283.89205 293.972194,7283.89205 C291.150266,7283.89205 288.862673,7286.17298 288.862673,7288.98792 M290.655732,7288.98792 C290.655732,7287.16159 292.140329,7285.67967 293.972194,7285.67967 C295.80406,7285.67967 297.288657,7287.16159 297.288657,7288.98792 C297.288657,7290.81525 295.80406,7292.29716 293.972194,7292.29716 C292.140329,7292.29716 290.655732,7290.81525 290.655732,7288.98792" transform="translate(-284.000000, -7279.000000)" />
    </svg>
  );
}

export default function Footer() {
  const { settings } = useSettings();
  const words = (settings.site_name || 'Exotic Pet World').split(' ');
  const line2 = words.length > 1 ? words.pop().toUpperCase() : '';
  const line1 = words.join(' ').toUpperCase();
  const useLogo = settings.app_logo_mode === 'logo' && !!settings.app_logo;
  const wa = settings.whatsapp || '';

  return (
    <footer className="border-t border-forest-500/20" style={{ background: 'linear-gradient(135deg, #1A2E1A, #0F1F0F)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            {useLogo ? (
              <img src={uploadUrl(settings.app_logo)} alt={settings.site_name} className="h-9 w-auto max-w-[180px] object-contain object-left" />
            ) : (
              <>
                <div className="w-10 h-10 rounded-2xl flex items-center justify-center flex-shrink-0" style={{ background: `linear-gradient(135deg, ${settings.app_color}, ${settings.app_color}99)` }}>
                  <span className="material-symbols-outlined text-white text-xl" style={{ fontVariationSettings: "'FILL' 1" }}>{settings.app_icon || 'pets'}</span>
                </div>
                <div>
                  <div className="font-display font-bold text-sm text-white">{line1}</div>
                  {line2 && <div className="text-xs text-neutral-400 tracking-wide">{line2}</div>}
                </div>
              </>
            )}
          </div>
          <p className="text-sm text-neutral-400 leading-relaxed mb-6">{settings.tagline}</p>

          <div className="space-y-2 mb-6">
            <p className="text-sm font-bold text-white">{settings.site_name || 'Exotic Pet World'}</p>
            {settings.alamat && <p className="text-sm text-neutral-400 leading-relaxed">{settings.alamat}</p>}
            {settings.telepon && <p className="text-sm text-neutral-400">{settings.telepon}</p>}
            {settings.email && <p className="text-sm text-neutral-400">{settings.email}</p>}
          </div>

          <div className="flex gap-3">
            <a href={settings.instagram || '#'} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full flex items-center justify-center bg-white/10 hover:scale-110 hover:rounded-2xl active:rounded-3xl active:scale-95 transition-all duration-300">
              <InstagramIcon className="w-[18px] h-[18px] text-white" />
            </a>
            {wa && (
              <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full flex items-center justify-center bg-white/10 hover:scale-110 hover:rounded-2xl active:rounded-3xl active:scale-95 transition-all duration-300">
                <WhatsAppIcon className="w-[18px] h-[18px] text-white" />
              </a>
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-1 md:gap-6">
          <FooterAccordion title="Navigasi" items={NAV_ITEMS.slice(0, 3)} />
          <FooterAccordion title="Info" items={INFO_ITEMS} />
        </div>
        <div>
          <h4 className="text-white font-bold text-sm mb-5 tracking-wider uppercase">Ikuti Kami</h4>
          <p className="text-sm text-neutral-400 mb-4">Dapatkan update event terbaru dan tips edukasi satwa.</p>
          {wa && (
            <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-4 py-3.5 rounded-xl text-sm font-semibold text-white shadow-md hover:shadow-lg hover:rounded-2xl active:rounded-3xl active:scale-[0.98] transition-all duration-300" style={{ background: '#25D366' }}>
              <WhatsAppIcon className="w-[18px] h-[18px]" />
              +{wa}
            </a>
          )}
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center">
        <p className="text-xs text-neutral-500">&copy; {new Date().getFullYear()} {settings.site_name}. All rights reserved.</p>
      </div>
    </footer>
  );
}
